export default "__VITE_ASSET__DPByIfJ5__"